import { Button, Tooltip, useBoolean } from "@chakra-ui/react";
import { LngLat } from "mapbox-gl";
import React, { useEffect, useMemo, useState } from "react";
import { FaDirections } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { RoutePoint, useRoute } from "../../data/mazemap.api";

type Props = {
  lng: number;
  lat: number;
};

const DirectionsButton = ({ lng, lat }: Props) => {
  const [error, setError] = useBoolean();
  const [loading, setLoading] = useBoolean();
  const navigate = useNavigate();

  const handleClick = () => {
    setLoading.on();
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        navigate(
          `/directions/${pos.coords.longitude},${pos.coords.latitude}/${lng},${lat}`
        );
      },
      () => {
        setError.on();
        setLoading.off();
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 20000,
      }
    );
  };

  return (
    <Button
      leftIcon={<FaDirections />}
      colorScheme="lancsBlue"
      onClick={handleClick}
      isLoading={loading}
    >
      {error ? "Failed to fetch directions. Try again." : "Directions"}
    </Button>
  );
};

export default DirectionsButton;
